<app-nav></app-nav>

<main class="main-content">
  <router-outlet></router-outlet>
</main>

<app-booking-modal></app-booking-modal>